import React from "react"

import SEO from "../components/seo"
import Layout from "../components/layout"
import { LocationMap } from "../components/FindUs"

const FindUsPage = () => {
  return (
    <Layout>
      <SEO title="Find Us" />
      <LocationMap />
    </Layout>
  )
}

export default FindUsPage
